module.exports = __webpack_public_path__ + "media/bootstrap-icons/mic-fill-1d9497e5.svg";